import { Box } from '@mui/material'
import { C1Link } from 'components/core/links/C1Link'
import { C1TableRedux, C1TableReduxColumn } from 'components/core/list/C1Table/C1TableRedux'
import List from 'components/core/list/index'
import { userColsMap, UserListColumns } from 'components/core/user/C1UsersList'
import { useErrorReporting } from 'components/no-ui/error-reporting/datadog'
import { QUERIES } from 'components/pages/explore/query/Query'
import { UserValue } from 'lib/actions/user'
import { routes } from 'lib/routes'
import { ExportDataRequest, QueryId } from 'pbts/c1/api/exportdata/v1/exportdata'
import { UsersWithoutManagerRequest } from 'pbts/c1/api/user/v1/user'
import { FC, useCallback, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { usersWithoutManager } from 'redux_toolkit/users'
import { ExportData } from './ExportData'
import { StructuredSearchStyles } from './styles'

const exportDataActionRequest = ExportDataRequest.create({
    queryId: QueryId.USERS_WITHOUT_MANAGER,
    request: {
        oneofKind: 'usersWithoutManagerRequest',
        usersWithoutManagerRequest:
            UsersWithoutManagerRequest.create({ expandMask: { paths: ['*'] } }),
    },
})

const cols: Array<C1TableReduxColumn<UserValue>> = [
    userColsMap[UserListColumns.user],
    userColsMap[UserListColumns.status],
    userColsMap[UserListColumns.roles],
    userColsMap[UserListColumns.managers],
    {
        field: 'actions',
        isSticky: () => true,
        Component: ({ row }) => <Box pl={1} pr={1} component="span">
            <C1Link href={routes.users.detail(row.id)}>
                <FormattedMessage id="component_access_policy_list_view_option_label" defaultMessage="View" />
            </C1Link>
        </Box>,
    },
]

export const UsersWithoutManagerReport: FC = () => {
    const [page, setPage] = useState<number>(0)
    const { data, isError, isLoading, getPage, canLoadMore, error } = usersWithoutManager.useUsersWithoutManager(
        UsersWithoutManagerRequest.create({ expandMask: { paths: ['*'] } }),
        {},
    )

    const onPageChange = useCallback(
        async (n: number) => {
            await getPage(n)
            setPage(n)
        },
        [getPage],
    )

    useErrorReporting(isError, error, QUERIES.UsersWithoutManager)

    const userTable = useMemo(
        () => (
            <C1TableRedux
                data={data}
                cols={cols}
                canLoadMore={canLoadMore}
                isError={isError}
                isLoading={isLoading}
                onPageChange={onPageChange}
                error={error}
                page={page}
            />
        ),
        [canLoadMore, data, error, isError, isLoading, onPageChange, page],
    )

    return <>
        <Box sx={StructuredSearchStyles.exportDataBox}>
            <ExportData exportDataRequest={exportDataActionRequest} />
        </Box>
        <List<UserValue> table={userTable} />
    </>
}
